// This component will wrap the component in a withRouter HOC, and pass the params and history objects as a prop to the wrapped component.

import React from 'react';
import {
  useMatch,
  useNavigate,
} from "react-router-dom";

interface withRouterProps {
  path: string;
  component?: any;
}

const WithRouter: React.FC<withRouterProps> = ({path, component}) => {
  const match = useMatch(path);
  const navigate = useNavigate();
  const history = {
    goBack: () => {
      navigate(-1);
    },
    push:(arg:any) => {
      navigate(arg);
    }
  }
  const Component = component;
  return (
    <Component match={match} history={history} />
  )
}

export default WithRouter;
